
import Vue from 'vue'
import UiIcon from '@/components/UiIcon.vue'
import { resolveSunsetBannerText } from '@/services/orgSunset'

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export default Vue.extend({
  name: 'OrgSunsetWarningBanner',
  components: { UiIcon },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    organization() { return this.$store.getters.organization },
    brandColor() {
      return this.organization?.brand?.color || '#ff567e'
    },
    visible(): boolean {
      if (!this.organization?.id) return false
      if (this.$route.name === 'OrganizationSunset') return false
      if (this.$route.name === 'SuperAdmin') return false
      return this.$store.getters.isOrgSunsetWarningVisible
    },
    sunset() {
      return this.$store.getters.organizationSunset
    },
    localeIsDe() {
      return this.$i18n.locale === 'de'
    },
    formattedDate() {
      return this.$store.getters.sunsetWarningFormattedDate
    },
    messageVars() {
      return {
        date: this.formattedDate,
        orgName: this.organization.brand.name,
      }
    },
    headlinePlain(): string {
      return resolveSunsetBannerText(
        this.sunset,
        'headline',
        this.localeIsDe,
        this.$t('headline') as string,
        this.messageVars
      )
    },
    headlineHtml(): string {
      return this.highlightDate(this.headlinePlain)
    },
    detailsPlain(): string {
      return resolveSunsetBannerText(
        this.sunset,
        'details',
        this.localeIsDe,
        this.$t('details') as string,
        this.messageVars
      )
    },
    detailsHtml(): string {
      return this.highlightDate(this.detailsPlain)
    },
  },
  methods: {
    highlightDate(text: string): string {
      const safe = escapeHtml(text)
      const date = escapeHtml(this.formattedDate)
      return safe.replace(
        date,
        `<strong class="org-sunset-warning__date">${date}</strong>`
      )
    },
  },
  watch: {
    'organization.id'() {
      this.expanded = false
    },
  },
})
